import React from "react";
import { connect, DispatchProp } from "react-redux";
import { NavigationType } from "../../models/enums/NavigationType";
import { Navigation } from "../../components/page/Navigation";
import { StoreState } from "../../models/states/StoreState";
import { ThemeModel } from "../../models/ThemeModel";
import { getSettingBoolean } from "../../models/utilities/settingUtilities";
import { __isQuestionVisible__ } from "../../expressions/parser";
import { ShortcutModel } from "../../models/ShortcutModel";
import { selectNavigationDisabled } from "../../redux/selectors/interview/navigation";

interface Props {
    onNavigation(type: NavigationType): void;
    position: "top" | "bottom";
    showSecurityQuestion?: boolean;
}

interface StateProps {
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    hideBackButton: boolean;
    disabled: boolean;
    theme: ThemeModel;
    language: string;
    shortcuts: ShortcutModel[];
}

class NavigationContainerImpl extends React.PureComponent<Props & StateProps & DispatchProp, {}> {
    render() {
        return <Navigation {...this.props} />;
    }
}

const hideBackButton = (state: StoreState) =>
    state.interview.navigation.currentPage.questions.some(
        (q) => __isQuestionVisible__(q, state.interview) && getSettingBoolean(q, "HideBackButton"),
    ) || !getSettingBoolean(state.interview.questionnaire, "ALLOW_BACKWARD_JUMPS");

const mapStateToProps = (state: StoreState, props: Props): Props & StateProps => ({
    ...props,
    shortcuts: state.interview.questionnaire.shortcuts,
    language: state.interview.language,
    disabled: selectNavigationDisabled(state),
    hasNextPage: state.interview.navigation.hasNextPage,
    hasPreviousPage: state.interview.navigation.hasPreviousPage,
    hideBackButton: hideBackButton(state),
    theme: state.interview.theme,
});

export const NavigationContainer = connect(mapStateToProps)(NavigationContainerImpl);
